<template>
  <el-container class="full-height">
      <el-main class="page-content">
          <el-main class="container">
              <Nav>
                  <div slot="left">
                        <div class="search-box">
                            <el-input class="input" placeholder="请输入企业名称/用户昵称/手机号搜索" v-model.trim="inputVal" clearable></el-input>
                            <el-button type="primary" style="margin-left: 30px" @click="handleSearch">搜索</el-button>
                        </div>

                        <div class="select-box">
                            <span>状态赛选</span>
                            <el-select v-model="selectType" @change="handleSelectType" clearable placeholder="请选择状态">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>

                        <div class="select-box">
                            <span>产业筛选</span>
                            <el-select v-model="selectIndustry" @change="handleIndustry" clearable placeholder="请选择产业">
                                <el-option
                                    v-for="item in industryList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                  </div>
              </Nav>

              <div class="table-box">
                  <div class="table-nav-box">
                      <div class="item" :class="{'active': this.navActive === 'all'}" @click="handleSelectType(null, '')">全部</div>
                      <div class="item" :class="{'active': this.navActive === 'undone'}" @click="handleSelectType(0)">未完成</div>
                      <div class="item" :class="{'active': this.navActive === 'done'}" @click="handleSelectType(1)">已完成</div>
                  </div>
                  <Table
                    border
                    align="center"
                    :header-row-style="{height: '100px'}"
                    :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
                    :row-style="{height: '250px', overflowY: scroll}"
                    :column="tableData.column"
                    :data="tableData.data"
                    pagination
                    background
                    :paginationTop="'30px'"
                    :paginationAlign="'center'"
                    layout="prev, pager, next, sizes, jumper"
                    :page-sizes="[5, 10, 20, 30]"
                    :pager-count="5"
                    :current-page.sync="body.pageIndex"
                    :total="tableData.total"
                    :page-size="body.pageSize"
                    @size-change="handleSizeChange"
                    @p-current-change="handleCurrentChange"
                >
                </Table>
              </div>
          </el-main>
      </el-main>

      <el-dialog
        :visible.sync="showDialog"
        title="回复"
        :destroy-on-close="true"
        width="25%"
      >
        <el-input 
            type="textarea"
            show-word-limit
            placeholder="请输入回复内容"
            v-model="inputReply"
            maxlength="9999"
            :autosize="{ minRows: 10, maxRows: 20 }"/>
        <div class="btn-box">
            <el-button @click="handleCloseDialog">取消</el-button>
            <el-button type="primary" @click="handleConfimDialog">确认</el-button>
        </div>
      </el-dialog>

    <el-dialog :visible.sync="showImgDialog" width="40%">
        <el-image :src="previewImgUlr" fit="scale-down" lazy style="margin: 20px auto;">
        </el-image>
    </el-dialog>
  </el-container>
</template>

<script>
import {
    getRepairList,
    putReply,
    finshRepair
} from '@/api/complaint.js'
import { getIndustrySelectList } from '@/api/industry'
import env from '@/configs/env'
export default {
    data(){
        return{
            showImgDialog: false,
            inputReply: '',
            showDialog: false,
            navActive: 'all',
            selectType: '',
            typeList: [{
                value: 0,
                label: '未完成'
            },{
                value: 1,
                label: '已完成'
            }],
            industryList: [],
            selectIndustry: '',
            inputVal: '',
            body: {
                pageSize: 10,
                pageIndex: 1,
                word: '',
                status: '',
                industryUuid: ''
            },
            tableData: {
                total: 0,
                column: [
                    {
                        prop: 'orderNum',
                        label: '工单编号'
                    },
                    {
                        prop: 'createTime',
                        label: '提交时间'
                    },
                    {
                        prop: 'industryName',
                        label: '所在产业'
                    },
                    {
                        prop: 'enterpriseName',
                        label: '所属企业'
                    },
                    {
                        prop: 'linkMan',
                        label: '联系人'
                    },
                    {
                        prop: 'linkMobile',
                        label: '联系电话'
                    },
                    {
                        label: '报修区域',
                        render: (h, {row}) =>{
                            let text = ''
                            if(row.type === 0){
                                text = '公共区域'
                            } else if(row.type === 1){
                                text = '办公区域'
                            }
                            return <div>{text}</div>
                        }
                    },
                    {
                        prop: 'content',
                        label: '问题描述'
                    },
                    {
                        label: '图片',
                        width: 500,
                        render: (h, {row}) =>{
                            return row.pictureList.map((item, i) =>{
                                return h('img', {
                                    domProps: {
                                        src: `${window.$imgUrl}${row.pictureList[i]}`
                                    },
                                    style: {
                                        width: '100px',
                                        height: '100px',
                                        marginRight: '15px',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.previewImg(item)
                                        }
                                    }
                                })
                            })
                        }
                    },
                    {
                        label: '状态',
                        render: (h, {row}) =>{
                            let { status } = row
                            let text = ''
                            if(status === 0){
                                text = '未完成'
                            } else if(status === 1){
                                text = '已完成'
                            }
                            return <div>{text}</div>
                        }
                    },
                    {
                        prop: 'reply',
                        label: '回复内容',
                    },
                    {
                        label: '操作',
                        render: (h, {row}) => {
                            if(row.status === 0){
                               return (
                                    <div>
                                        <el-link underline={false} onClick={() => { this.handleReply(row) }} type='primary'>回复</el-link>&nbsp;&nbsp;
                                        <el-link underline={false} onClick={() => { this.handleConfim(row) }} type='primary'>完成</el-link>
                                    </div>
                                ) 
                            } else {
                                return (
                                    <div>
                                        <el-link underline={false} onClick={() => { this.handleConfim(row) }} type='primary'>完成</el-link>
                                    </div>
                                ) 
                            }
                            
                        }
                    },
                ],
                data: []
            },
            putBody: {
                reply: '',
                uuid: ''
            },
            previewImgUlr: ''
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.network().getIndustrySelectList()
            await this.network().getRepairList();
        },
        previewImg(item){
            this.showImgDialog = true,
            this.previewImgUlr = `${window.$imgUrl}${item}`
        },
        network(){
            return{
                getRepairList: async()=>{
                    let { data } = await getRepairList(this.body)
                    this.tableData.data = data.list
                    this.tableData.total = parseInt(data.total)
                },
                getIndustrySelectList: async() => {
                    const { data } = await getIndustrySelectList()
                    data.forEach(item => {
                        this.industryList.push({
                            value: item.uuid,
                            label: item.name
                        })
                    })
                },
                putReply: async ()=>{
                    await putReply(this.putBody)
                    this.$message.success('回复成功')
                    this.showDialog = false
                    this.network().getRepairList()
                },
                finshRepair: async(uuid)=>{
                    await finshRepair(uuid)
                    this.$message.success('成功')
                    this.network().getRepairList()
                }
            }
        },
        handleSearch(){
            this.body.word = this.inputVal 
            this.network().getRepairList()
        },
        handleSizeChange(size){
            this.body.pageSize = size
            this.body.pageIndex = 1
            this.network().getRepairList()
        },
        handleCurrentChange(page){
            this.body.pageIndex = page
            this.network().getRepairList()
        },
        handleReply(row){
            this.putBody.uuid = row.uuid
            this.showDialog = true
        },
        handleConfim(row){
            this.network().finshRepair(row.uuid)
        },
        handleSelectType(status){
            if(status === 0){
                this.navActive = 'undone'
            } else if(status === 1){
                this.navActive = 'done'
            } else {
                this.navActive = 'all'
            }
            this.body.status = status
            this.body.pageIndex = 1
            this.network().getRepairList()
        },
        handleIndustry(id) {
            this.body.industryUuid = id
            this.body.pageIndex = 1
            this.network().getRepairList()
        },
        handleCloseDialog(){
            this.inputReply = ''
            this.showDialog = false
        },
        handleConfimDialog(){
            if(this.inputReply === ''){
                this.$message.error('请输入内容!')
            } else{
                this.putBody.reply = this.inputReply
                this.network().putReply()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.select-box{
    margin-left: 60px;
    span{
        margin-right: 10px;
    }
}
.search-box{
    .input{
        width: 300px;
    }
}
.table-nav-box{
    margin-bottom: 30px;
    display: flex;
    .item{
        margin-right: 30px;
        cursor: pointer;
    }
    .active{
        font-weight: 900;
    }
}
/deep/.el-dialog{
  border-radius: 15px;
  text-align: center;
  .btn-box{
      margin-top: 30px;
      text-align: center;
  }
}

/deep/.el-table{
    tr td .cell{
        max-height: 250px;
        overflow-y: auto;
    }
}

</style>